import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dialog from 'components/platform/Dialog'
import { HeaderTitle } from 'components/platform/Pages'
import { getTenantPrivacy } from 'services/api/tenantService'
import {Redirect} from "react-router-dom";
import styles from './style.module.scss'

export const PrivacyManagementModal =  ( ) => {
  const [loading, setLoading] = useState(true)

  const [tenant, setTenant] = useState<any>(null)



  useEffect(() => {
    setLoading(true)
    getTenantPrivacy()
      .then( data => {
        if (!data.error) {
          setTenant(data.body)
          setLoading(false)
        }
      })
  }, [])

  if(loading) {
    return null
  }

  if(!tenant) {
    return null
  }

  if ( tenant.is_valid ) {
    return null
  }

  return (
    <Redirect to='/resume/privacy' />
  )

  return (
    (
      <Dialog
        header={
          <>
            <HeaderTitle title={<FormattedMessage id='global.privacy_management' />} />
          </>
        }
        modal
        dialogClass='custom-topbar'
        draggable={false}
        opened
        width={800}
      >
        <div className='mb-2'>
          <b>Note:</b> <FormattedMessage id='global.accept_privacy' />
        </div>

        <div className={styles.privacyBox} dangerouslySetInnerHTML={{__html: tenant.privacy1 as string}} />

        <label className='flex items-start' htmlFor='checkPrivacy1'>
          <input
            className='mr-2.5 inline-block'
            type='checkbox'
            value=''
            disabled={loading}
            id='checkPrivacy1'
            onChange={() => {
              // handleUpdate(e, { where: 1, type: tenant.privacy1_status })
            }}
          />
          <div className='text-sm'>{tenant.privacy_label}</div>

        </label>
      </Dialog>
    )
  )
}
